import { extendTheme } from "@chakra-ui/react";
import { createTheme } from "@material-ui/core/styles";
import red from "@material-ui/core/colors/red";
import './TouchFeedback.css';

const chakraTheme = extendTheme({
  colors: {
    brand: {
      white: "#FFFFFF",
      black: "#000000",
      red: "#EC2227",
      orange: "#F15B27",
    },
    semantic: {
      success: "#38A169",
      successBg: "#F4FDF3",
      error: "#E53E3E",
      focus: "#3182CE",
    },
  },
  fonts: {
    body: "Inter, sans-serif",
    heading: "Inter, sans-serif",
    mono: "Menlo, monospace",
  },
  styles: {
    global: {
      // Gate hover effects behind hover-capable media query.
      // Chakra v1 component variants don't process @media at-rules,
      // so we apply hover gating at the global CSS level.
      // Chakra v1 processes these through emotion's Global component.
      "@media (hover: hover)": {
        ".chakra-link:hover": {
          color: "var(--chakra-colors-gray-800)",
          textDecoration: "underline",
        },
      },
      // Prevent active/hover flash on disabled buttons
      ".chakra-button:disabled, .chakra-button[aria-disabled='true']": {
        pointerEvents: "none !important",
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "bold",
        borderRadius: "md",
      },
      defaultProps: {
        variant: "brand",
      },
      variants: {
        outline: {
          fontFamily: "heading",
        },
        brand: {
          fontFamily: "heading",
          bg: "linear-gradient(to right, #EC2227, #F15B27, #EC2227)",
          backgroundSize: "200% 100%",
          backgroundPosition: "left center",
          color: "white",
          transition: "background-position 0.3s ease, box-shadow 0.3s ease",
          _hover: {
            backgroundPosition: "right center",
            boxShadow: "md",
          },
          _focus: {
            backgroundPosition: "right center",
            boxShadow: "outline",
          },
          _disabled: {
            bg: "linear-gradient(to right, #EC2227, #F15B27, #EC2227)",
            backgroundSize: "200% 100%",
            backgroundPosition: "left center",
            opacity: 0.5,
          },
          _active: {
            bg: "linear-gradient(to right, #C01B20, #D04C20, #C01B20)",
            backgroundPosition: "right center",
          },
        },
      },
      sizes: {
        kiosk: {
          minH: 16,
          minW: "200px",
          fontSize: "xl",
          fontWeight: 700,
          px: 6,
          py: 6,
        },
      },
    },
    Link: {
      baseStyle: {
        color: "gray.600",
        textDecoration: "none",
      },
    },
  },
});

const muiTheme = createTheme({
  palette: {
    primary: red,
  },
  typography: {
    fontSize: 20,
  },
});

export { chakraTheme, muiTheme };
